import { Fragment } from "react";

import { DesktopRow } from "./DesktopRow";
import { GroupHeader } from "./GroupHeader";
import { Table, TableHead, TableHeadCell } from "./styles";
import { DesktopTableProps } from "./types";

export const DesktopTable: React.FC<DesktopTableProps> = ({
  groups,
  accountIdsByName,
  onEdit,
  onDuplicate,
  onDelete,
}) => (
  <Table>
    <TableHead>
      <TableHeadCell>Date</TableHeadCell>
      <TableHeadCell>Account</TableHeadCell>
      <TableHeadCell>Category</TableHeadCell>
      <TableHeadCell>Note</TableHeadCell>
      <TableHeadCell $align="right">Amount</TableHeadCell>
      <TableHeadCell />
    </TableHead>
    {groups.map((group) => (
      <Fragment key={group.dateKey}>
        <GroupHeader group={group} variant="desktop" />
        {group.transactions.map((transaction) => (
          <DesktopRow
            key={transaction.id}
            transaction={transaction}
            accountIdsByName={accountIdsByName}
            onEdit={onEdit}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
          />
        ))}
      </Fragment>
    ))}
  </Table>
);
